import { Box } from '@mui/material';
import useWidth from '../../../../../../components/Hooks/useWidth';
import { MediaFormatEnum } from '../../../../../general-settings/enums/mediaFormat.enum';
import useSelectedMediaIndex from '../../hooks/useSelectedMediaIndex';
import { ProductGalleryProps } from '../../interfaces/productGallery.interfaces';
import { useGalleryLayoutStyles } from '../../styles/gallery.styles';
import GalleryMainMedia from '../GalleryMainMedia/GalleryMainMedia';
import GalleryThumbStrip from '../GalleryThumbStrip/GalleryThumbStrip';
import { RECTANGULAR_ASPECT_RATIO, getRectangularThumbLayout } from './rectangularGallery.utils';

const RectangularGallery = ({
  medias,
  galleryWidth,
  onZoom,
  onMobileContainerCover,
}: ProductGalleryProps) => {
  const { largeWidthUp } = useWidth();
  const { selectedIndex, setSelectedIndex } = useSelectedMediaIndex(medias);
  const { thumbWidth, thumbHeight, thumbRows, thumbColumns, maxThumbs } =
    getRectangularThumbLayout(galleryWidth);

  const { classes } = useGalleryLayoutStyles({
    aspectRatio: RECTANGULAR_ASPECT_RATIO,
    hasFixedMainMedia: false,
  });

  const thumbIndexes = medias
    .map((_, index) => index)
    .filter((index) => !largeWidthUp || index !== selectedIndex);

  return (
    <Box className={classes.root}>
      <GalleryMainMedia
        medias={medias}
        selectedIndex={selectedIndex}
        className={classes.mainMediaBox}
        dotsClassName={classes.mediaDotsIndicator}
        onMobileContainerCover={onMobileContainerCover}
        onSelectIndex={setSelectedIndex}
        onZoom={onZoom}
      />

      <GalleryThumbStrip
        medias={medias}
        mediaFormat={MediaFormatEnum.RECTANGULAR}
        thumbIndexes={thumbIndexes}
        thumbWidth={thumbWidth}
        thumbHeight={thumbHeight}
        thumbRows={thumbRows}
        thumbColumns={thumbColumns}
        maxThumbs={maxThumbs}
        isScrollable
        selectedIndex={selectedIndex}
        onZoom={onZoom}
        onSelect={setSelectedIndex}
      />
    </Box>
  );
};

export default RectangularGallery;
